import { isGeorgia } from "../../../../../src/utils/helpers/isGeorgia";


export const fieldNames = {
  NAME_OF_COMPANY: "nameOfCompany",
  DIRECTOR_FULL_NAME: "directorFullName",
  IDENTIFICATION_NUMBER: "IdentificationNumber",
  LEGAL_FORM: "legalForm",
  CITY: "city",
  COUNTRY_CODE: "countryCode",
  COUNTRY: "country",
  CITY_VILLAGE: "cityVillage",
  APARTMENT_NUMBER: "apartmentNumber",
  STREET: "street",
  HOME_NUMBER: "homeNumber",
  IS_CITY: "isCity",
  VILLAGE: "village",
  IS_ACTUAL_ADDRESS: "isActualAddress",
  LEGAL_ADDRESS: "legal_address",
  ACTUAL_ADDRESS: "actual_address",
  FIRSTNAME: "FirstName",
  LASTNAME: "lastname",
  CITY_ID: "city",
  CITIZENSHIP: "citizenship",
  COUNTRYOFBIRTH: "countryofbirth",
  CITYOFBIRTH: "cityofbirth",
  DATEOFBIRTH: "dateofbirth",
  CONFIRMATION_STATUS: "ConfirmationStatus",
  AGREEMENT_HTML_BASED_ON_STEP_THREE: "agreementHTMLForConfirmation",
  DATA_UPDATE_CHANGES:"dataUpdateChanges",
  CHANGE_PHONE_SMS:"changePhoneSms",
  ADD_PHONE_SMS:"addPhoneSms",
  CHANGE_AUTH_NUMBER:"changeAuthNumber",
  ADD_AUTH_NUMBER:"addAuthNumber",
  DEVICE_CONFIRMATION:"deviceConfirmation",
  IB_CHANNEL:"ibChannel",
  ONE_TIME_CODE:"oneTimeCode",
  CODE_QUESTION:"codeQuestion",
  CODE_ANSWER:"codeAnswer",
  MOBILE_NUMBER_CHANGE:"mobileNumberChange",
  EMAIL_CHANGE:"emailChange",
};

// function returns true if we have address.actualAddress.country and address.Actualaddress.homeNUmber
export function doWeHaveActualAddress(address) {
  const { [fieldNames.ACTUAL_ADDRESS]: actualAddress } = address;
  if (!actualAddress) return false;
  const { [fieldNames.COUNTRY]: country } = actualAddress;

  return !!country;
}

export function isContentGeorgian(lang) {
  return lang === "ka";
}

export function withNameSpace(namespace, fieldName) {
  return namespace ? `${namespace}.${fieldName}` : fieldName;
}

export function withTwoNameSpaces(namespace, secondName, fieldName) {
  return namespace ? `${namespace}.${secondName}.${fieldName}` : fieldName;
}

export function moveGeorgiaUp(data) {
  return data.sort(({ referenceId }) => {
    if (isGeorgia(referenceId)) {
      return -1;
    }
    return 1;
  });
}
export const IB_CHANNEL_OPTIONS ={
  mobilenumberChange: '0',
  emailChange: '1'
}

export const CHANGE_INFO_OPTIONS =(initialPhone)=>{ 
  return{
    changePhone: {
      id: "1",
      names: [
        {
          initialState: initialPhone? initialPhone : '',
          name: fieldNames.CHANGE_PHONE_SMS
        }
    ],  
    },
    addPhone:{
      id:"2",
      names: [
        {
          initialState: initialPhone? initialPhone : '',
          name: fieldNames.ADD_PHONE_SMS
        }
    ],  
    },
    changeAuthNumber:{
      id:"3",
      names: [
        {
          initialState: initialPhone? initialPhone : '',
          name: fieldNames.CHANGE_AUTH_NUMBER
        }
    ],  
    },
    addAuthNumber:{
      id:"4",
      names: [
        {
          initialState: initialPhone? initialPhone : '',
          name: fieldNames.ADD_AUTH_NUMBER
        }
    ],  
    },
    changeAuthMethod:{
      id: "5",
      names: [
        {
          initialState: '',
          name: fieldNames.ONE_TIME_CODE
        }
    ],  
    },
    changeGenerationTool:{
      id: "6",
      names: [
        {
          name: fieldNames.DEVICE_CONFIRMATION,
          initialState: '',
        }
      ],
    },
    changeIbCode:{
      id:"7",
      names: [
        {
          initialState: '',
          name: fieldNames.CODE_QUESTION,
        },
        {
          name: fieldNames.CODE_ANSWER
        }
      ],
    },
    changeIbEmailAddress:{
      id:"8",
    },
    changeSourceIbPassword:{
      id:"9",
      names: [
        {
          name: fieldNames.IB_CHANNEL,
          initialState: []
        }
      ],
    }
  }
}
